// Shape shared by every account-ish API response that carries a display name
// (PortfolioEngineAccount, AccountLookup, ...) — just the fields resolveAccountName needs.
interface NamedAccount {
    accountGUID: string;
    accountNamePlain?: string;
    accountName?: { plainText?: string };
}

// accountNamePlain isn't always populated; fall back to the encrypted name's
// plain text, then the GUID. Single source for sort, search, and display.
export const resolveAccountName = (account: NamedAccount): string =>
    (account.accountNamePlain || account.accountName?.plainText || account.accountGUID).trim();
